import { ReactNode } from 'react';

import styles from './table.module.css';

export type TableBodyProps = {
	children: ReactNode | ReactNode[];
};

export const TableBody = ({ children }: TableBodyProps) => <tbody className={styles.body}>{children}</tbody>;
